import _ from 'lodash';
import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';
import user from 'js/lib/user';

import CourseProgress from 'pages/open-course/common/models/courseProgress';

import courseProgressPromise from 'bundles/catalogP/promises/courseProgress';
import ProgressStoreClass from 'bundles/in-course-stores/stores/ProgressStore';

const deepFilterRecursive = (source: any, keyName: string) => {
  delete source[keyName];

  _.forEach(source, (v) => {
    if (_.isObject(v)) {
      deepFilterRecursive(v, keyName);
    }
  });
};

// Copies the object and deletes any key matching the keyName, and any key in any sub-objects.
const deepFilterKey = (source: any, keyName: string) => {
  const newObject = Object.assign({}, source);
  deepFilterRecursive(newObject, keyName);
  return newObject;
};

/**
 * Generally this is used on the client to update any progress indicators. In those cases
 * updateProgress can be called to update.
 *
 * rawCourseProgress is passed through only for the initial hydration step.
 */
export const updateProgress = function (
  actionContext: ActionContext,
  // @ts-expect-error ts-migrate(2749) FIXME: 'CourseProgress' refers to a value, but is being u... Remove this comment to see the full error message
  { courseProgress, rawCourseProgress }: { courseProgress: CourseProgress; rawCourseProgress?: any }
) {
  if (rawCourseProgress == null) {
    actionContext.dispatch('LOAD_COURSE_PROGRESS', {
      courseProgress,
      rawCourseProgress: null,
    });
  } else {
    actionContext.dispatch('LOAD_COURSE_PROGRESS', {
      courseProgress,
      rawCourseProgress,
    });
  }
};

export const getProgress = (
  actionContext: ActionContext,
  {
    courseId,
    refreshProgress,
  }: {
    courseId: string;
    refreshProgress: boolean;
  }
) => {
  if (actionContext.getStore(ProgressStoreClass).hasLoaded() && !refreshProgress) {
    return Q();
  }

  return courseProgressPromise(
    {
      id: `${user.get().id}~${courseId}`,
      fields: ['gradedAssignmentGroupProgress'],
    },
    { forceUpdate: true }
  )
    .then(({ courseProgress, rawCourseProgress }: $TSFixMe /* TODO: type courseProgressPromise */) => {
      const oldRawCourseProgress = actionContext.getStore(ProgressStoreClass).rawCourseProgress;
      // Since reloading progress is expensive, don't load it again if it is unchanged.
      // Filter out the 'timestamp' field since it changes every time and is irrelevant.
      if (
        !actionContext.getStore(ProgressStoreClass).hasLoaded() ||
        !_.isEqual(deepFilterKey(oldRawCourseProgress, 'timestamp'), deepFilterKey(rawCourseProgress, 'timestamp'))
      ) {
        return actionContext.executeAction(updateProgress, {
          courseProgress,
          rawCourseProgress,
        });
      }

      return null;
    })
    .fail(() => {
      return actionContext.executeAction(updateProgress, {
        courseProgress: new CourseProgress(),
      });
    });
};
